
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/impact-alternative",
      function () {
        return require("private-next-pages/impact-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/impact-alternative"])
      });
    }
  